const CATEGORIES = {
  CLEANSER: 'Cleanser',
  EXFOLIATOR: 'Exfoliator',
  MASK: 'Mask',
  TONER: 'Toner',
  SERUM: 'Serum',
  EYE_TREATMENT: 'Eye Treatment',
  BOOSTER: 'Booster',
  MOISTURIZER: 'Moisturizer',
  SPF: 'SPF',
  MIST: 'Mist',
  BODY: 'Body',
};

export default CATEGORIES;
